/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "јуче",
        "-2": "прекјуче",
        "0": "данас",
        "1": "сутра",
        "2": "прекосутра",
        "future": {
          "few": "за {0} дана",
          "one": "за {0} дан",
          "other": "за {0} дана"
        },
        "past": {
          "few": "прије {0} дана",
          "one": "прије {0} дана",
          "other": "прије {0} дана"
        }
      },
      "day-narrow": {
        "-1": "јуче",
        "-2": "прекјуче",
        "0": "данас",
        "1": "сутра",
        "2": "прекосутра",
        "future": {
          "few": "за {0} д.",
          "one": "за {0} д.",
          "other": "за {0} д."
        },
        "past": {
          "few": "прије {0} д.",
          "one": "прије {0} д.",
          "other": "прије {0} д."
        }
      },
      "day-short": {
        "-1": "јуче",
        "-2": "прекјуче",
        "0": "данас",
        "1": "сутра",
        "2": "прекосутра",
        "future": {
          "few": "за {0} д.",
          "one": "за {0} д.",
          "other": "за {0} д."
        },
        "past": {
          "few": "прије {0} д.",
          "one": "прије {0} д.",
          "other": "прије {0} д."
        }
      },
      "hour": {
        "0": "овог сата",
        "future": {
          "few": "за {0} сата",
          "one": "за {0} сат",
          "other": "за {0} сати"
        },
        "past": {
          "few": "прије {0} сата",
          "one": "прије {0} сата",
          "other": "прије {0} сати"
        }
      },
      "hour-narrow": {
        "0": "овог сата",
        "future": {
          "few": "за {0} ч.",
          "one": "за {0} ч.",
          "other": "за {0} ч."
        },
        "past": {
          "few": "прије {0} ч.",
          "one": "прије {0} ч.",
          "other": "прије {0} ч."
        }
      },
      "hour-short": {
        "0": "овог сата",
        "future": {
          "few": "за {0} ч.",
          "one": "за {0} ч.",
          "other": "за {0} ч."
        },
        "past": {
          "few": "прије {0} ч.",
          "one": "прије {0} ч.",
          "other": "прије {0} ч."
        }
      },
      "minute": {
        "0": "овог минута",
        "future": {
          "few": "за {0} минута",
          "one": "за {0} минут",
          "other": "за {0} минута"
        },
        "past": {
          "few": "прије {0} минута",
          "one": "прије {0} минута",
          "other": "прије {0} минута"
        }
      },
      "minute-narrow": {
        "0": "овог минута",
        "future": {
          "few": "за {0} мин.",
          "one": "за {0} мин.",
          "other": "за {0} мин."
        },
        "past": {
          "few": "прије {0} мин.",
          "one": "прије {0} мин.",
          "other": "прије {0} мин."
        }
      },
      "minute-short": {
        "0": "овог минута",
        "future": {
          "few": "за {0} мин.",
          "one": "за {0} мин.",
          "other": "за {0} мин."
        },
        "past": {
          "few": "прије {0} мин.",
          "one": "прије {0} мин.",
          "other": "прије {0} мин."
        }
      },
      "month": {
        "-1": "прошлог мјесеца",
        "0": "овог мјесеца",
        "1": "сљедећег мјесеца",
        "future": {
          "few": "за {0} мјесеца",
          "one": "за {0} мјесец",
          "other": "за {0} мјесеци"
        },
        "past": {
          "few": "прије {0} мјесеца",
          "one": "прије {0} мјесеца",
          "other": "прије {0} мјесеци"
        }
      },
      "month-narrow": {
        "-1": "прошлог мјес.",
        "0": "овог мјес.",
        "1": "сљедећег м.",
        "future": {
          "few": "за {0} м.",
          "one": "за {0} м.",
          "other": "за {0} м."
        },
        "past": {
          "few": "прије {0} м.",
          "one": "прије {0} м.",
          "other": "прије {0} м."
        }
      },
      "month-short": {
        "-1": "прошлог мјес.",
        "0": "овог мјес.",
        "1": "сљедећег мјес.",
        "future": {
          "few": "за {0} мјес.",
          "one": "за {0} мјес.",
          "other": "за {0} мјес."
        },
        "past": {
          "few": "прије {0} мјес.",
          "one": "прије {0} мјес.",
          "other": "прије {0} мјес."
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "прошлог квартала",
        "0": "овог квартала",
        "1": "сљедећег квартала",
        "future": {
          "few": "за {0} квартала",
          "one": "за {0} квартал",
          "other": "за {0} квартала"
        },
        "past": {
          "few": "прије {0} квартала",
          "one": "прије {0} квартала",
          "other": "прије {0} квартала"
        }
      },
      "quarter-narrow": {
        "-1": "прошлог квартала",
        "0": "овог квартала",
        "1": "следећег квартала",
        "future": {
          "few": "за {0} кв.",
          "one": "за {0} кв.",
          "other": "за {0} кв."
        },
        "past": {
          "few": "прије {0} кв.",
          "one": "прије {0} кв.",
          "other": "прије {0} кв."
        }
      },
      "quarter-short": {
        "-1": "прошлог квартала",
        "0": "овог квартала",
        "1": "следећег квартала",
        "future": {
          "few": "за {0} кв.",
          "one": "за {0} кв.",
          "other": "за {0} кв."
        },
        "past": {
          "few": "прије {0} кв.",
          "one": "прије {0} кв.",
          "other": "прије {0} кв."
        }
      },
      "second": {
        "0": "сада",
        "future": {
          "few": "за {0} секунде",
          "one": "за {0} секунду",
          "other": "за {0} секунди"
        },
        "past": {
          "few": "прије {0} секунде",
          "one": "прије {0} секунде",
          "other": "прије {0} секунди"
        }
      },
      "second-narrow": {
        "0": "сада",
        "future": {
          "few": "за {0} с.",
          "one": "за {0} с.",
          "other": "за {0} с."
        },
        "past": {
          "few": "прије {0} с.",
          "one": "прије {0} с.",
          "other": "прије {0} с."
        }
      },
      "second-short": {
        "0": "сада",
        "future": {
          "few": "за {0} сек.",
          "one": "за {0} сек.",
          "other": "за {0} сек."
        },
        "past": {
          "few": "прије {0} сек.",
          "one": "прије {0} сек.",
          "other": "прије {0} сек."
        }
      },
      "week": {
        "-1": "прошле седмице",
        "0": "ове седмице",
        "1": "сљедеће седмице",
        "future": {
          "few": "за {0} седмице",
          "one": "за {0} седмицу",
          "other": "за {0} седмица"
        },
        "past": {
          "few": "прије {0} седмице",
          "one": "прије {0} седмице",
          "other": "прије {0} седмица"
        }
      },
      "week-narrow": {
        "-1": "прошле с.",
        "0": "ове с.",
        "1": "сљедеће с.",
        "future": {
          "few": "за {0} с.",
          "one": "за {0} с.",
          "other": "за {0} с."
        },
        "past": {
          "few": "прије {0} с.",
          "one": "прије {0} с.",
          "other": "прије {0} с."
        }
      },
      "week-short": {
        "-1": "прошле седм.",
        "0": "ове седм.",
        "1": "сљедеће седм.",
        "future": {
          "few": "за {0} седм.",
          "one": "за {0} седм.",
          "other": "за {0} седм."
        },
        "past": {
          "few": "прије {0} седм.",
          "one": "прије {0} седм.",
          "other": "прије {0} седм."
        }
      },
      "year": {
        "-1": "прошле године",
        "0": "ове године",
        "1": "сљедеће године",
        "future": {
          "few": "за {0} године",
          "one": "за {0} годину",
          "other": "за {0} година"
        },
        "past": {
          "few": "прије {0} године",
          "one": "прије {0} године",
          "other": "прије {0} година"
        }
      },
      "year-narrow": {
        "-1": "прошле г.",
        "0": "ове г.",
        "1": "сљедеће г.",
        "future": {
          "few": "за {0} г.",
          "one": "за {0} г.",
          "other": "за {0} г."
        },
        "past": {
          "few": "прије {0} г.",
          "one": "прије {0} г.",
          "other": "прије {0} г."
        }
      },
      "year-short": {
        "-1": "прошле год.",
        "0": "ове год.",
        "1": "сљедеће год.",
        "future": {
          "few": "за {0} год.",
          "one": "за {0} год.",
          "other": "за {0} год."
        },
        "past": {
          "few": "прије {0} год.",
          "one": "прије {0} год.",
          "other": "прије {0} год."
        }
      }
    },
    "locale": "sr-Cyrl-BA"
  });
}